import { Button } from '../design'
import { SESSION_COPY } from './copy'

const LockMark = () => (
  <svg
    className="no-access-mark"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.5"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
  >
    <rect x="4" y="10.5" width="16" height="10" rx="1" />
    <path d="M8 10.5V7.5a4 4 0 0 1 8 0" />
  </svg>
)

export const NoAccessScreen = ({ onSignOut }: { onSignOut: () => void }) => (
  <div className="entry no-access">
    <div className="entry-band hatch" aria-hidden="true" />
    <main className="entry-sheet">
      <LockMark />
      <h1 className="no-access-title">{SESSION_COPY.noAccessTitle}</h1>
      <p className="no-access-body">{SESSION_COPY.noAccessBody}</p>
      <Button variant="primary" size="large" className="no-access-exit" onClick={onSignOut}>
        {SESSION_COPY.signOut}
      </Button>
    </main>
  </div>
)
